import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from 'src/app/modules/core/service/v2/abstractRepositoryV2';
import { DeviceDefinitionModel } from '../../../api/entity/deviceDefinition.model';

@Injectable({
  providedIn: 'root'
})
export class DeviceDefinitionRepository extends AbstractRepositoryV2<DeviceDefinitionModel> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
    super('MedicalDeviceDefinition', serviceElementsFactory, injector);
  }
}

